<template>
  <div class="formBtn">
    <b-button id="nextStepBtn" :disabled="disabled" @click="onClick">
      <slot>{{ $t(localeConsts.nextButton) }}</slot>
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'NextStepButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localeConsts: {
        nextButton: 'STATUSREPORTS.NEXT'
      }
    }
  },
  methods: {
    onClick() {
      this.$emit('clickEvent')
    }
  }
}
</script>
